"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDelete = exports.usePut = exports.usePatch = exports.usePost = exports.useGet = void 0;
const lodash_1 = require("lodash");
const querystring = __importStar(require("@zipit/ls-core-sdk/dist/querystring"));
const ls_core_sdk_1 = require("@zipit/ls-core-sdk");
const async_1 = require("./async");
const superagent = __importStar(require("superagent"));
const isFunction = (val) => typeof val === 'function';
const error = (request) => request().catch(error => {
    throw (0, ls_core_sdk_1.superagentError)(error);
});
const useGet = (url, headerFn, config) => (0, async_1.useAsync)(() => {
    let req;
    const task = (query) => {
        const queryStr = (0, lodash_1.trim)(querystring.stringify(query));
        const queryUrl = queryStr.length > 0
            ? `${url}${(url.indexOf('?') > -1 ? '&' : '?') + queryStr}`
            : url;
        return error(() => __awaiter(void 0, void 0, void 0, function* () {
            const headers = isFunction(headerFn) ? yield headerFn() : undefined;
            req = superagent.get(queryUrl);
            if (headers) {
                req = req.set(headers);
            }
            const res = yield req;
            return res.body;
        }));
    };
    const abort = () => req === null || req === void 0 ? void 0 : req.abort();
    return { task, abort };
}, config);
exports.useGet = useGet;
const usePost = (url, headerFn, config) => (0, async_1.useAsync)(() => {
    let req;
    const task = (data) => error(() => __awaiter(void 0, void 0, void 0, function* () {
        const headers = isFunction(headerFn) ? yield headerFn() : undefined;
        req = superagent.post(url).send(data);
        if (headers) {
            req = req.set(headers);
        }
        const res = yield req;
        return res.body;
    }));
    const abort = () => req === null || req === void 0 ? void 0 : req.abort();
    return { task, abort };
}, config);
exports.usePost = usePost;
const usePatch = (url, headerFn, config) => (0, async_1.useAsync)(() => {
    let req;
    const task = (data) => error(() => __awaiter(void 0, void 0, void 0, function* () {
        const headers = isFunction(headerFn) ? yield headerFn() : undefined;
        req = superagent.patch(url).send(data);
        if (headers) {
            req = req.set(headers);
        }
        const res = yield req;
        return res.body;
    }));
    const abort = () => req === null || req === void 0 ? void 0 : req.abort();
    return { task, abort };
}, config);
exports.usePatch = usePatch;
const usePut = (url, headerFn, config) => (0, async_1.useAsync)(() => {
    let req;
    const task = (data) => error(() => __awaiter(void 0, void 0, void 0, function* () {
        const headers = isFunction(headerFn) ? yield headerFn() : undefined;
        req = superagent.put(url).send(data);
        if (headers) {
            req = req.set(headers);
        }
        const res = yield req;
        return res.body;
    }));
    const abort = () => req === null || req === void 0 ? void 0 : req.abort();
    return { task, abort };
}, config);
exports.usePut = usePut;
const useDelete = (url, headerFn, config) => (0, async_1.useAsync)(() => {
    let req;
    const task = (query) => error(() => __awaiter(void 0, void 0, void 0, function* () {
        const queryStr = (0, lodash_1.trim)(querystring.stringify(query));
        const queryUrl = queryStr.length > 0
            ? `${url}${(url.indexOf('?') > -1 ? '&' : '?') + queryStr}`
            : url;
        const headers = isFunction(headerFn) ? yield headerFn() : undefined;
        req = superagent.delete(queryUrl);
        if (headers) {
            req = req.set(headers);
        }
        const res = yield req;
        return res.body;
    }));
    const abort = () => req === null || req === void 0 ? void 0 : req.abort();
    return { task, abort };
}, config);
exports.useDelete = useDelete;
//# sourceMappingURL=api.js.map